/* eslint-env WebSocket */
/* globals WebSocket:true */
/* eslint-disable */

import { funcEncryptData, funcDecryptData } from '../crypt/HyCrypt';
import { MGConstants, RequestAPI } from './mg-constants';
import * as connectBikeAPI from '@/api/connect-bike';

var WebSocketWrapper;
WebSocketWrapper = (function () {
  function WebSocketWrapper (wsUrl, apicustomer, apikey) {
    this.connectionState = '';
    this.ws = '';
    this.wsUrl = wsUrl;
    this.api_customer = apicustomer;
    this.api_key = apikey;
    this.ConsoleData = {};
    this.BroseMotorData = {};
    this.DriveData = {};
  }

  WebSocketWrapper.prototype.disconnect = function () {
    this.ws.close();
  };
  WebSocketWrapper.prototype.Ws_Send = function (message) {
    // ==============Encrypt Message=======================//
    // console.log('Websocket send', message);
    let encryptMessage = funcEncryptData(message);
    // send websocket
    try {
      this.ws.send(encryptMessage);
    } catch (error) {
      this.onError(MGConstants.getWebSocketError().DuplicateConnect);
    }
  };
  WebSocketWrapper.prototype.connect = function () {
    try {
      this.ws = new WebSocket(this.wsUrl);
      this.ws.onmessage = function (evt) {
        // [Message]when a message is received from the server
        try {
          var jsonResult = JSON.parse(evt.data);
          var decryptMessage = funcDecryptData(jsonResult);
          // 判斷是否ErrorCode===20001
          if (decryptMessage.ErrorCode === 20001) {
            this.onError(MGConstants.getWebSocketError().Decryption);
            return;
          }
        } catch (error) {
          this.onError(MGConstants.getWebSocketError().ReceiveDataError);
          return;
        }
        this.ParseMessageType(decryptMessage);
      }.bind(this);

      this.ws.onopen = function (evt) {
        var _self = this;
        var apiName = '/verifyToken';
        var params = {
          'Token': _self.api_key,
          'Customer': _self.api_customer
        };
        //* **需要經由 DB assign api key & HyMGBL 更動 DB name 才會重新啟動*/

        // var encryptMessage = funcEncryptData(params)
        // RequestAPI.CallHyenaAPI(apiName, encryptMessage, function (data) {
        //   if (data.ErrorCode > 0) {
        //     _self.onError(data)
        //     return
        //   }
        //   var objMGConstants = MGConstants.getWebRequest()
        //   var objSendMessage = Object.assign({}, objMGConstants.Verification_Token)
        //   objSendMessage.VerificationResult = data
        //   objSendMessage.Customer = _self.api_customer
        //   _self.Ws_Send(objSendMessage)
        // })
        this.onConnected('Connected');
      }.bind(this);

      this.ws.onclose = function (evt) {
        // [Close]WebSocket connection's is closed.
        this.onDisconnected(evt);
      }.bind(this);

      this.ws.onerror = function (evt) {
        // this.onError(MIDConstants.getWebSocketError().Connection)
        // [Error]when an error occurs.
        // this.onDisconnected(evt)
      };
    } catch (error) {
      this.onError(MGConstants.getWebSocketError().WebSocketError);
    }
  };
  WebSocketWrapper.prototype.ParseMessageType = function (objMsg) {
    var mgMessageType = MGConstants.getMessageType();
    var failCode = MGConstants.getMGStatusCode().Fail;
    // console.log('mgMessageType', mgMessageType)//可查看有哪些 mgMessageType
    // console.log('objMsg.MessageType', objMsg.MessageType);
    /**
     * 在 overview 只 call mgMessageType 2(Connection), 4(Information) 7 (Customized)
     */
    switch (objMsg.MessageType) {
      case mgMessageType.Verification:
        if (objMsg.Status === failCode) {
          this.onError(MGConstants.getWebSocketError().API_KeyError);
          this.disconnect();
        } else {
          this.onConnected('Connected');
        }
        break;
      case mgMessageType.Connection:
        this.ParseConnectInstruction(objMsg);
        break;
      case mgMessageType.Information:
        this.ParseInfoInstruction(objMsg);
        break;
      case mgMessageType.Diagnostics:
        this.ParseDiagnosistInstruction(objMsg);
        break;
      case mgMessageType.ListenBtn:
        this.ParseListenBtnInstruction(objMsg);
        break;
      case mgMessageType.Upgrade:
        this.ParseUpgrdeInstruction(objMsg);
        break;
      case mgMessageType.Customized:
        this.ParseCustomizeInstruction(objMsg);
        break;
      case mgMessageType.AutoUpdate:
        this.ParseAutoUpdateInstruction(objMsg);
        break;
      case mgMessageType.Exception:
        this.onError(MGConstants.getWebSocketError().Exception);
        break;
      case mgMessageType.DecryptionError:
        this.onError(MGConstants.getWebSocketError().Decryption);
        break;
      case mgMessageType.FoolProofing:
        this.onError(MGConstants.getWebSocketError().FoolProofing);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_MessageTypeError);
        break;
    }
  };
  WebSocketWrapper.prototype.ParseConnectInstruction = function (objMsg) {
    var MG_Instruction = MGConstants.getConnectInstruction();
    var rlt = {};
    switch (objMsg.Instruction) {
      case MG_Instruction.HY_Dongle:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onCheckComport(rlt);
        break;
      case MG_Instruction.HY_eBike:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onCheckPower(rlt);
        break;
      case MG_Instruction.HY_ConnctStatus:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onCheckConnectStatus(rlt);
        break;
      case MG_Instruction.HY_Console:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onCheckConsoleStatus(rlt);
        break;
      case MG_Instruction.HY_Display:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onCheckDisplayStatus(rlt);
        break;
      case MG_Instruction.HY_ChangeBike:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onChangeBike(rlt);
        break;
      case MG_Instruction.HY_CheckDeviceUnconnection:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onCheckDeviceUnconnection(rlt);
        break;
      case MG_Instruction.HY_StopCheckDeviceUnconnection:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onStopCheckDeviceUnconnection(rlt);
        break;
      case MG_Instruction.KeyError:
        this.onError(MGConstants.getWebSocketError().Req_InstructionError);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };
  WebSocketWrapper.prototype.ParseInfoInstruction = function (objMsg) {
    var MG_Instruction = MGConstants.getInfoInstruction();
    var rlt = {};
    switch (objMsg.Instruction) {
      case MG_Instruction.HY_GetConsoleBtns:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetConsoleBtns(rlt);
        break;
      case MG_Instruction.HY_BikeInfo:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetBikeInfo(rlt);
        break;
      case MG_Instruction.HY_Battery:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetBatteryInfo(rlt);
        break;
      case MG_Instruction.HY_FirmwareVer:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetSystemInfo(rlt);
        break;
      case MG_Instruction.HY_ErrorCode:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetHistoryErrorCode(rlt);
        break;
      case MG_Instruction.HY_ReadPara:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onReadPara(rlt);
        break;
      case MG_Instruction.HY_GetBikeId:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetBikeId(rlt);
        break;
      case MG_Instruction.HY_GetDeviceInfo:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetDeviceInfo(rlt);
        break;
      case MG_Instruction.HY_WriteBikeId:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteBikeId(rlt);
        break;
      case MG_Instruction.HY_GetFrameNumber:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetFrameNumber(rlt);
        break;
      case MG_Instruction.HY_MAC:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetMacAddress(rlt);
        break;
      case MG_Instruction.HY_Lighton:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetLightonStatus(rlt);
        break;
      case MG_Instruction.HY_CommonCustomizenInfo:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetCommonCustomizenInfo(rlt);
        break;
      case MG_Instruction.HY_SystemConfig:
        rlt = this.RemoveMGTypeKey(objMsg);
        if (rlt.Status == 1004) {
          this.GetSystemConfig(); // Polling again
        }
        else {
          this.onSystemConfig(rlt);
        }
        break;
      case MG_Instruction.HY_WriteFrameNo:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteFrameNo(rlt);
        break;
      case MG_Instruction.HY_WriteMid:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteMid(rlt);
        break;
      case MG_Instruction.HY_GetUpdateStatus:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onGetUpdateStatus(rlt);
        break;
      case MG_Instruction.HY_WriteParameters:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteParameters(rlt);
        break;
      case MG_Instruction.KeyError:
        this.onError(MGConstants.getWebSocketError().Req_InstructionError);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };
  WebSocketWrapper.prototype.ParseDiagnosistInstruction = function (objMsg) {
    var MG_Instruction = MGConstants.getDiagnosistInstruction();
    var rlt = {};
    switch (objMsg.Instruction) {
      case MG_Instruction.Diagnostics_Cancel:
        break;
      case MG_Instruction.HY_Display_Status:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisDisplayAuto(rlt);
        break;
      case MG_Instruction.HY_Display_Flash:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisDisplayFlash(rlt);
        break;
      case MG_Instruction.HY_Display_Round:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisDisplayRound(rlt);
        break;
      case MG_Instruction.HY_Display_TestStop:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisDisplayTestStop(rlt);
        break;
      case MG_Instruction.HY_Console_Btns:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisConsoleBtns(rlt);
        break;
      case MG_Instruction.HY_HallSensor:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisHallSensor(rlt);
        break;
      case MG_Instruction.HY_Speed:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisSpeedSensor(rlt);
        break;
      case MG_Instruction.HY_Torque:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisTorqueSensor(rlt);
        break;
      case MG_Instruction.HY_Cadence:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisCadenceSensor(rlt);
        break;
      case MG_Instruction.HY_Charger:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisCharger(rlt);
        break;
      case MG_Instruction.HY_Controller:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisController(rlt);
        break;
      case MG_Instruction.HY_Battery:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisBattery(rlt);
        break;
      case MG_Instruction.HY_Hallsensor_Status:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisHallSensorAuto(rlt);
        break;
      case MG_Instruction.HY_Speed_Status:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisSpeedSensorAuto(rlt);
        break;
      case MG_Instruction.HY_Torque_Status:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisTorqueSensorAuto(rlt);
        break;
      case MG_Instruction.HY_Cadence_Status:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisCadenceSensorAuto(rlt);
        break;
      case MG_Instruction.HY_FrontLight:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisFrontLightAuto(rlt);
        break;
      case MG_Instruction.HY_RearLight:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisRearLightAuto(rlt);
        break;
      case MG_Instruction.HY_GripBrake:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisGripBrake(rlt);
        break;
      case MG_Instruction.HY_MotorSpeed:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisMotorSpeed(rlt);
        break;
      case MG_Instruction.HY_TirePressure:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisTirePressure(rlt);
        break;
      case MG_Instruction.BR_DU_Speed:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisBRSpeedSensor(rlt);
        break;
      case MG_Instruction.BR_DU_Torque:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisBRTorqueSensor(rlt);
        break;
      case MG_Instruction.BR_DU_Cadence:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisBRCadenceSensor(rlt);
        break;
      case MG_Instruction.HY_Motor:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDiagnosisMotor(rlt);
        break;
      case MG_Instruction.KeyError:
        this.onError(MGConstants.getWebSocketError().Req_InstructionError);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };

  WebSocketWrapper.prototype.ParseListenBtnInstruction = function (objMsg) {
    var MG_Instruction = MGConstants.getListenBtnInstruction();
    var rlt = {};
    switch (objMsg.Instruction) {
      case MG_Instruction.StartListenBtn:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onStartListenBtn(rlt);
        break;
      case MG_Instruction.DetectBtn:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.ParseDetectBtn(rlt);
        break;
      case MG_Instruction.StopListenBtn:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onStopListenBtn(rlt);
        break;
      case MG_Instruction.KeyError:
        this.onError(MGConstants.getWebSocketError().Req_InstructionError);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };

  WebSocketWrapper.prototype.ParseUpgrdeInstruction = function (objMsg) {
    var MG_Instruction = MGConstants.getUpgrdeInstruction();
    var rlt = {};
    switch (objMsg.Instruction) {
      case MG_Instruction.HY_Dongle:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onUpgradeDongle(rlt);
        break;
      case MG_Instruction.HY_Console:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onUpgradeConsole(rlt);
        break;
      case MG_Instruction.HY_Driver:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onUpgradeDriver(rlt);
        break;
      case MG_Instruction.HY_Display:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onUpgradeDisplay(rlt);
        break;
      case MG_Instruction.BR_DriveUnit:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onUpgradeBroseDrive(rlt);
        break;
      case MG_Instruction.KeyError:
        this.onError(MGConstants.getWebSocketError().Req_InstructionError);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };

  WebSocketWrapper.prototype.ParseDetectBtn = function (objMsg) {
    var btnName = MGConstants.getButtonName();
    switch (objMsg.Message) {
      case btnName.w:
        this.onDetectPowerBtn(objMsg);
        break;
      case btnName.u:
        this.onDetectUpBtn(objMsg);
        break;
      case btnName.d:
        this.onDetectDownBtn(objMsg);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };

  WebSocketWrapper.prototype.ParseCustomizeInstruction = function (objMsg) {
    var MG_Instruction = MGConstants.getCustomizeInstruction();
    // console.log(MG_Instruction)
    // console.log(MG_Instruction.HY_Write_WheelSize)
    // console.log('objMsg.MessageType', objMsg.MessageType, 'objMsg.Instruction', objMsg.Instruction)
    var rlt = {};
    switch (objMsg.Instruction) {
      case MG_Instruction.HY_Write_MaintenanceWarning:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteMaintenanceWarning(rlt);
        break;
      case MG_Instruction.HY_Write_NextMaintenanceODO:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteNextMaintenanceODO(rlt);
        break;
      case MG_Instruction.HY_Write_TorqueResponse:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteTorqueResponse(rlt);
        break;
      case MG_Instruction.HY_Write_EnergyBar:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteEnergyBar(rlt);
        break;
      case MG_Instruction.HY_Write_StartUpLightON:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteStartUpLightON(rlt);
        break;
      case MG_Instruction.HY_Write_SpeedUnits:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteSpeedUnits(rlt);
        break;
      case MG_Instruction.HY_Write_StartUpPowerLevel:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteStartUpPowerLevel(rlt);
        break;
      case MG_Instruction.HY_Write_PowerLevels:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWritePowerLevels(rlt);
        break;
      case MG_Instruction.HY_Write_AutoSleep:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteAutoSleep(rlt);
        break;
      case MG_Instruction.HY_Write_WheelSize:
        // console.log('HY_Write_WheelSize', MG_Instruction.HY_Write_WheelSize)
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onWriteWheelSize(rlt);
        break;
      case MG_Instruction.HY_Write_Reset:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onResetSetting(rlt);
        break;
      case MG_Instruction.QW_PatchHideDisplayAstLevel:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onResetDisplayAstLevel(rlt);
        break;
      case MG_Instruction.HY_ReadModePowerLevel:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onReadModePowerLevel(rlt);
        break;
      case MG_Instruction.KeyError:
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };

  WebSocketWrapper.prototype.RemoveMGTypeKey = function (message) {
    var rlt = Object.assign({}, message);
    delete rlt['MessageType'];
    delete rlt['Instruction'];
    return rlt;
  };

  WebSocketWrapper.prototype.ParseBikeInfo = async function (message) {
    var _self = this;
    var successCode = MGConstants.getMGStatusCode().Pass;
    if (message.Status === successCode) {
      if (message.ConsoleBtns.length === 0) {
        const encryptMessage = funcEncryptData({ PartNo: message.PartNo });
        await connectBikeAPI.getConsoleInfo(encryptMessage)
          .then(res => {
            const data = funcDecryptData(JSON.parse(res))
            if (data.ErrorCode > 0) {
              _self.onError(data);
              return;
            }
            var objMGConstants = MGConstants.getWebRequest();
            var objSendMessage = Object.assign({}, objMGConstants.Information_HY_GetConsoleBtns);
            objSendMessage.RequestResult = data;
            _self.Ws_Send(objSendMessage);
          });
      }
    }
    this.onGetBikeInfo(message);
  };

  WebSocketWrapper.prototype.ParseAutoUpdateInstruction = function (objMsg) {
    var MG_Instruction = MGConstants.getAutoUpdateInstruction();
    var rlt = {};
    switch (objMsg.Instruction) {
      case MG_Instruction.Check_Version:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onCheckVersion(rlt);
        break;
      case MG_Instruction.Download:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDownloadMg(rlt);
        break;
      case MG_Instruction.Download_Cancel:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onDownloadMgCancel(rlt);
        break;
      case MG_Instruction.Installer:
        rlt = this.RemoveMGTypeKey(objMsg);
        this.onInstallerMg(rlt);
        break;
      case MG_Instruction.KeyError:
        this.onError(MGConstants.getWebSocketError().Req_InstructionError);
        break;
      default:
        this.onError(MGConstants.getWebSocketError().Res_InstructionError);
        break;
    }
  };

  // 2019/01/28 always pass function
  WebSocketWrapper.prototype.CheckMotorConnection = function () {
    var rlt = { Status: 1000 };
    this.onCheckMotorConnection(rlt);
  };
  WebSocketWrapper.prototype.CheckBatteryConnection = function () {
    var rlt = { Status: 1000 };
    this.onCheckBatteryConnection(rlt);
  };
  WebSocketWrapper.prototype.CheckElockConnection = function () {
    var rlt = { Status: 1000 };
    this.onCheckElockConnection(rlt);
  };
  WebSocketWrapper.prototype.CheckIOTConnection = function () {
    var rlt = { Status: 1000 };
    this.onCheckIOTConnection(rlt);
  };

  WebSocketWrapper.prototype.CheckComport = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_Dongle);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.CheckPower = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_eBike);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.CheckConnectStatus = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_Status);
    this.Ws_Send(objSendMessage);
  };
  /**
   * 2019/03/25
   * BTS 熱插拔 確認斷線
   *
   */
  WebSocketWrapper.prototype.CheckDeviceUnconnection = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_CheckDeviceUnconnection);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.StopCheckDeviceUnconnection = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_StopCheckDeviceUnconnection);
    this.Ws_Send(objSendMessage);
  };
  /**
   * 2019/01/28 update: add CheckConsoleStatus() 、CheckDisplayStatus(), ChangeBike()
   */
  WebSocketWrapper.prototype.CheckConsoleStatus = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_Console);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.CheckDisplayStatus = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_Display);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.ChangeBike = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Connection_HY_ChangeBike);
    this.Ws_Send(objSendMessage);
  };

  // Detect Button
  WebSocketWrapper.prototype.StartListenBtn = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.BtnListener_StartBtnListener);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.StopListenBtn = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.BtnListener_StopBtnListener);
    this.Ws_Send(objSendMessage);
  };
  // Bike Information
  WebSocketWrapper.prototype.GetBikeInfo = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_BikeInfo);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.GetBatteryInfo = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_Battery);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.GetSystemInfo = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_FirmwareVer);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.GetHistoryErrorCode = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_ErrorCode);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.GetUpdateStatus = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_GetUpdateStatus);
    this.Ws_Send(objSendMessage);
  };

  /**
   * 2019/02/19
   * 增加 GetCommonCustomizenInfo() GetSystemConfig()
   */
  WebSocketWrapper.prototype.GetCommonCustomizenInfo = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_CommonCustomizenInfo);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.GetSystemConfig = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_SystemConfig);
    this.Ws_Send(objSendMessage);
  };
  /**
   * 2019/01/28 updated
   * add GetFrameNumber() GetMacAddress() GetLightonStatus()
   */
  WebSocketWrapper.prototype.GetFrameNumber = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_GetFrameNumber);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.GetMacAddress = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_MAC);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.GetLightonStatus = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_Lighton);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.WriteFrameNo = function (frameNo) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_WriteFrameNo);
    objSendMessage.FrameNo = frameNo;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteMid = function (type, mid) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_WriteMid);
    objSendMessage.Mid = mid;
    objSendMessage.Type = type;
    this.Ws_Send(objSendMessage);
  };

  /**
   * 2021/05/04 
   * add WriteParameters()
   */
    WebSocketWrapper.prototype.WriteParameters = function ({PartType, Parameters}) {
      var objMGRequest = MGConstants.getWebRequest();
      var objSendMessage = Object.assign({}, objMGRequest.Information_HY_WriteParameters);
      objSendMessage.PartType = PartType;
      objSendMessage.Parameters = Parameters;
      this.Ws_Send(objSendMessage);
    };

  /**
   * 2018/12/25 update
   * add ReadPara() GetBikeId() GetDeviceInfo() WriteBikeId()
   */
  WebSocketWrapper.prototype.ReadPara = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_ReadPara);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.GetBikeId = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_GetBikeId);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.GetDeviceInfo = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_GetDeviceInfo);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteBikeId = function (bikeID) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Information_HY_WriteBikeId);
    objSendMessage.NewBikeId = bikeID;
    this.Ws_Send(objSendMessage);
  };

  // Diagnosis function
  WebSocketWrapper.prototype.DiagnosisDisplayAuto = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Display_Status);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisDisplayFlash = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Display_Flash);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisDisplayRound = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Display_Round);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisDisplayTestStop = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Display_TestStop);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.CancelDiagnosis = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_Cancel);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisConsoleBtns = function (consolebtns, seconds) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Console_Btns);
    objSendMessage.ConsoleBtns = consolebtns;
    objSendMessage.Seconds = seconds;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisHallSensorAuto = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_Hallsensor_Status);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisHallSensor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_HallSensor);
    objSendMessage.Seconds = seconds;
    objSendMessage.Times = times;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisSpeedSensorAuto = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_Speed_Status);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisSpeedSensor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Speed);
    objSendMessage.Seconds = seconds;
    objSendMessage.Times = times;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisTorqueSensorAuto = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_Torque_Status);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisTorqueSensor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Torque);
    objSendMessage.Seconds = seconds;
    objSendMessage.Times = times;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisCadenceSensorAuto = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_Cadence_Status);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisCadenceSensor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Cadence);
    objSendMessage.Seconds = seconds;
    objSendMessage.Times = times;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisCharger = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Charger);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisController = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Controller);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisBattery = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_Battery);
    this.Ws_Send(objSendMessage);
  };
  /**
   * 2019/01/28
   * add DiagnosisFrontLightAuto() DiagnosisRearLightAuto() DiagnosisGripBrake() DiagnosisMotorSpeed(), DiagnosisTirePressure()
   * add brose diagnosis function DiagnosisBRSpeedSensor() DiagnosisBRTorqueSensor() DiagnosisBRCadenceSensor()
   */
  WebSocketWrapper.prototype.DiagnosisFrontLightAuto = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_FrontLight);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DiagnosisRearLightAuto = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_RearLight);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DiagnosisGripBrake = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_GripBrake);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DiagnosisMotorSpeed = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_MotorSpeed);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisTirePressure = function (tirepressure) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_HY_TirePressure);
    objSendMessage.TirePressure = tirepressure;
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DiagnosisBRSpeedSensor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_BR_DU_Speed);
    objSendMessage.Seconds = seconds;
    objSendMessage.Times = times;
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DiagnosisBRTorqueSensor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_BR_DU_Torque);
    objSendMessage.Seconds = seconds;
    objSendMessage.Times = times;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.DiagnosisBRCadenceSensor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_BR_DU_Cadence);
    objSendMessage.Seconds = seconds;
    objSendMessage.Times = times;
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DiagnosisMotor = function (seconds, times) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Diagnostics_Motor);
    this.Ws_Send(objSendMessage);
  };

  /**
   * 2019/01/17
   * add Upgrade component function
   */
  WebSocketWrapper.prototype.UpgradeDongle = function (fwdata, checksum, rule = 1) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Upgrade_HY_Dongle);
    objSendMessage.FwData = fwdata;
    objSendMessage.CheckSum = checksum;
    objSendMessage.Rule = rule;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.UpgradeConsole = function (fwdata, checksum, rule = 1) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Upgrade_HY_Console);
    objSendMessage.FwData = fwdata;
    objSendMessage.CheckSum = checksum;
    objSendMessage.Rule = rule;
    // objSendMessage.FwData = this.ConsoleData.FwData
    // objSendMessage.CheckSum = this.ConsoleData.CheckSum
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.UpgradeDisplay = function (fwdata, checksum, rule = 1) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Upgrade_HY_Display);
    objSendMessage.FwData = fwdata;
    objSendMessage.CheckSum = checksum;
    objSendMessage.Rule = rule;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.UpgradeDriver = function (fwdata, checksum, rule = 1) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Upgrade_HY_Driver);
    objSendMessage.FwData = fwdata;
    objSendMessage.CheckSum = checksum;
    objSendMessage.Rule = rule;
    // objSendMessage.FwData = this.DriveData.FwData
    // objSendMessage.CheckSum = this.DriveData.CheckSum
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.UpgradeBroseDrive = function (fwdata, checksum, parameterdata, parametercsv) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Upgrade_BR_DriveUnit);
    objSendMessage.FwData = fwdata;
    objSendMessage.CheckSum = checksum;
    objSendMessage.CsvData = parameterdata;
    objSendMessage.CsvCheckSum = parametercsv;
    // objSendMessage.FwData = this.BroseMotorData.FwData
    // objSendMessage.CheckSum = this.BroseMotorData.CheckSum
    // objSendMessage.CsvData = this.BroseMotorData.ParametersFWData
    // objSendMessage.CsvCheckSum = this.BroseMotorData.ParametersFWCheckSum
    this.Ws_Send(objSendMessage);
  };

  /**
   * 2019/02/19 update
   * add new setting functions
   * WriteMaintenanceWarning()
   * WriteNextMaintenanceODO()
   * WriteEnergyBar()
   * WriteStartUpLightON()
   * WriteSpeedUnits()
   * WriteStartUpPowerLevel()
   * WriteWheelSize（）
   * ResetSetting()
   * ReadModePowerLevel()
   * WriteTorqueResponse()
   */
  WebSocketWrapper.prototype.WriteMaintenanceWarning = function (maintenanceWarning) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_MaintenanceWarning);
    objSendMessage.MaintenanceWarning = maintenanceWarning;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteNextMaintenanceODO = function (nextODO) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_NextMaintenanceODO);
    objSendMessage.NextODO = nextODO;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteEnergyBar = function (energyIndicator) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_EnergyBar);
    objSendMessage.EnergyIndicator = energyIndicator;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteStartUpLightON = function (startUpLight) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_StartUpLightON);
    objSendMessage.StartUpLight = startUpLight;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteSpeedUnits = function (speedUnit) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_SpeedUnits);
    objSendMessage.SpeedUnit = speedUnit;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteStartUpPowerLevel = function (assistMode) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_StartUpPowerLevel);
    objSendMessage.AssistMode = assistMode;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteWheelSize = function (wheelSize) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_WheelSize);
    objSendMessage.WheelSize = wheelSize;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.ResetSetting = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_Reset);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WritePowerLevels = function (perfMode, powerLevel, levels) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_PowerLevels);
    objSendMessage.PerfMode = perfMode;
    objSendMessage.PowerLV = powerLevel;
    objSendMessage.Levels = levels;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteAutoSleep = function (autoSleep) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_AutoSleep);
    objSendMessage.SysAutoSleep = autoSleep;
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.WriteTorqueResponse = function (TorqueResponse) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_Write_TorqueResponse);
    objSendMessage.TorqueResponse = TorqueResponse;
    this.Ws_Send(objSendMessage);
  };
  /**
   * 2021/11/11 update
   * add ResetDisplayAstLevel 覆寫舊版的 display (275)
   */
  WebSocketWrapper.prototype.ResetDisplayAstLevel = function () {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_QW_PatchHideDisplayAstLevel);
    this.Ws_Send(objSendMessage);
  };
  WebSocketWrapper.prototype.ReadModePowerLevel = function (mode) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Customize_HY_ReadModePowerLevel);
    objSendMessage.Mode = mode;
    this.Ws_Send(objSendMessage);
  };

  /**
   * 2019/05/21 update
   * add new auto update functions
   * CheckVersion()
   * DownloadMg()
   * DownloadMgCancel()
   * InstallerMg()
   */

  WebSocketWrapper.prototype.CheckVersion = function (mode) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Autoupdate_Check_Version);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DownloadMg = function (mode) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Autoupdate_Download);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.DownloadMgCancel = function (mode) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Autoupdate_Download_Cancel);
    this.Ws_Send(objSendMessage);
  };

  WebSocketWrapper.prototype.InstallerMg = function (mode) {
    var objMGRequest = MGConstants.getWebRequest();
    var objSendMessage = Object.assign({}, objMGRequest.Autoupdate_Installer);
    this.Ws_Send(objSendMessage);
  };

  // on event function
  WebSocketWrapper.prototype.onConnected = function (data) {};
  WebSocketWrapper.prototype.onDisconnected = function (evt) {};
  WebSocketWrapper.prototype.onError = function (data) {};

  WebSocketWrapper.prototype.onCheckComport = function (data) {};
  WebSocketWrapper.prototype.onCheckPower = function (data) {};
  WebSocketWrapper.prototype.onCheckConnectStatus = function (data) {};
  // 2019/01/28 add onCheckConsoleStatus() onCheckDisplayStatus() onChangeBike()
  WebSocketWrapper.prototype.onCheckConsoleStatus = function (data) {};
  WebSocketWrapper.prototype.onCheckDisplayStatus = function (data) {};
  WebSocketWrapper.prototype.onChangeBike = function (data) {};
  WebSocketWrapper.prototype.onCheckDeviceUnconnection = function (data) {};
  WebSocketWrapper.prototype.onStopCheckDeviceUnconnection = function (data) {};

  WebSocketWrapper.prototype.onGetBikeInfo = function (data) {};
  WebSocketWrapper.prototype.onGetConsoleBtns = function (data) {};
  WebSocketWrapper.prototype.onGetBatteryInfo = function (data) {};
  WebSocketWrapper.prototype.onGetSystemInfo = function (data) {};
  WebSocketWrapper.prototype.onGetHistoryErrorCode = function (data) {};
  WebSocketWrapper.prototype.onWriteFrameNo = function (data) {};
  WebSocketWrapper.prototype.onWriteMid = function (data) {};
  WebSocketWrapper.prototype.onGetUpdateStatus = function (data) {};
  // 2021/05/04 add WriteParameters()
  WebSocketWrapper.prototype.onWriteParameters = function (data) {};

  // 2019/02/19 add onSystemConfig() onGetCommonCustomizenInfo()

  WebSocketWrapper.prototype.onGetCommonCustomizenInfo = function (data) {};
  WebSocketWrapper.prototype.onSystemConfig = function (data) {};
  // 2019/01/28 add onGetFrameNumber() onGetMacAddress() GetLightonStatus()
  WebSocketWrapper.prototype.onGetFrameNumber = function (data) {};
  WebSocketWrapper.prototype.onGetMacAddress = function (data) {};
  WebSocketWrapper.prototype.onGetLightonStatus = function (data) {};

  /**
   * 2018/12/25 update
   * add readPara() getBikeId() getDeviiceInfo witeBikeId()
   */
  WebSocketWrapper.prototype.onReadPara = function (data) {};
  WebSocketWrapper.prototype.onGetBikeId = function (data) {};
  WebSocketWrapper.prototype.onGetDeviceInfo = function (data) {};
  WebSocketWrapper.prototype.onWriteBikeId = function (data) {};

  WebSocketWrapper.prototype.onDiagnosisDisplayAuto = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisDisplayFlash = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisDisplayRound = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisDisplayTestStop = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisConsoleBtns = function (data) {};

  WebSocketWrapper.prototype.onDiagnosisHallSensorAuto = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisHallSensor = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisSpeedSensorAuto = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisSpeedSensor = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisTorqueSensorAuto = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisTorqueSensor = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisCadenceSensorAuto = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisCadenceSensor = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisCharger = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisController = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisBattery = function (data) {};

  // 2019/01/28 add onDiagnosisFrontLightAuto() onDiagnosisRearLightAuto() onDiagnosisGripBrake()
  WebSocketWrapper.prototype.onDiagnosisFrontLightAuto = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisRearLightAuto = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisGripBrake = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisMotorSpeed = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisTirePressure = function (data) {};

  WebSocketWrapper.prototype.onDiagnosisBRSpeedSensor = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisBRTorqueSensor = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisBRCadenceSensor = function (data) {};
  WebSocketWrapper.prototype.onDiagnosisMotor = function (data) {};

  // 2019/01/28 add always pass function
  WebSocketWrapper.prototype.onCheckMotorConnection = function (data) {};
  WebSocketWrapper.prototype.onCheckBatteryConnection = function (data) {};
  WebSocketWrapper.prototype.onCheckElockConnection = function (data) {};
  WebSocketWrapper.prototype.onCheckIOTConnection = function (data) {};

  WebSocketWrapper.prototype.onStartListenBtn = function (data) {};
  WebSocketWrapper.prototype.onStopListenBtn = function (data) {};
  WebSocketWrapper.prototype.onDetectUpBtn = function (data) {};
  WebSocketWrapper.prototype.onDetectDownBtn = function (data) {};
  WebSocketWrapper.prototype.onDetectPowerBtn = function (data) {};

  // 2019/01/17 update , add Upgrade component functions
  WebSocketWrapper.prototype.onUpgradeDongle = function (data) {};
  WebSocketWrapper.prototype.onUpgradeConsole = function (data) {};
  WebSocketWrapper.prototype.onUpgradeDisplay = function (data) {};
  WebSocketWrapper.prototype.onUpgradeDriver = function (data) {};
  WebSocketWrapper.prototype.onUpgradeBroseDrive = function (data) {};

  // 2019/02/19 update , add setting functions

  WebSocketWrapper.prototype.onWriteMaintenanceWarning = function (data) {};
  WebSocketWrapper.prototype.onWriteNextMaintenanceODO = function (data) {};
  WebSocketWrapper.prototype.onWriteEnergyBar = function (data) {};
  WebSocketWrapper.prototype.onWriteStartUpLightON = function (data) {};
  WebSocketWrapper.prototype.onWriteSpeedUnits = function (data) {};
  WebSocketWrapper.prototype.onWriteStartUpPowerLevel = function (data) {};
  WebSocketWrapper.prototype.onWriteWheelSize = function (data) {};
  WebSocketWrapper.prototype.onResetSetting = function (data) {};
  WebSocketWrapper.prototype.onResetDisplayAstLevel = function (data) {};
  WebSocketWrapper.prototype.onWritePowerLevels = function (data) {};
  WebSocketWrapper.prototype.onWriteAutoSleep = function (data) {};
  WebSocketWrapper.prototype.onWriteTorqueResponse = function (data) {};
  WebSocketWrapper.prototype.onReadModePowerLevel = function (data) {};

  // 2019/05/21 update, add new auto update functions
  WebSocketWrapper.prototype.onCheckVersion = function (data) {};
  WebSocketWrapper.prototype.onDownloadMg = function (data) {};
  WebSocketWrapper.prototype.onDownloadMgCancel = function (data) {};
  WebSocketWrapper.prototype.onInstallerMg = function (data) {};

  return WebSocketWrapper;
})();

export default WebSocketWrapper;
